const localConstants = {
  dateMonthFormat: "MMM/YY",
  dateShortFormat: "MM/YYYY",
  monthDiff: 12,
};

export default localConstants;
